import zod from 'zod'

export const birthdaySchema = zod.object({
  show: zod.boolean(),
  dateOnly: zod.boolean(),
  date: zod.date().optional().nullable(),
})
